import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=fa45e1ec"
import script from "./pricelist.vue?vue&type=script&lang=ts"
export * from "./pricelist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports